import React from 'react';
import { isLoading } from 'resift';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

interface Props {
  title?: string;
  children: React.ReactNode;
  submitButtonCopy?: string;
  open: boolean;
  status?: number;
  disableSubmitButton?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

function SimpleConfirmationDialog({
  title = 'Are you sure?',
  children,
  open,
  status = 1,
  disableSubmitButton = false,
  onCancel,
  onSubmit,
  submitButtonCopy = 'Submit',
}: Props) {
  const loading = isLoading(status);

  return (
    <Dialog open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onSubmit}
          disabled={loading || disableSubmitButton}
        >
          {loading ? <>Submitting</> : <>{submitButtonCopy}</>}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SimpleConfirmationDialog;
